/**
 * File navigation.js.
 *
 * Handles toggling the Search form on mobile
 */

(function () {
  /**
   * Sub menu mobile handle
   */
  const searchForm = document.querySelector(".site-header-search");
  const submitIcon = document.querySelector(".search-open-icon");
  const closeBtn = document.querySelector(".search-open-icon.close-btn");

  // Return early if the navigation doesn't exist.
  if (!searchForm) {
    return;
  }

  const headerSearchButton = document.getElementById(
    "site-header-search-toggle"
  );

  // Return early if the button doesn't exist.
  if (!headerSearchButton) {
    return;
  }

  const searchOpenHandler = () => {
    $(
      ".site-header-naviation, .phone-content, .search-icon, .site-header-search"
    ).toggle();

    $(".search-open-icon").show();

    $(".search-wrapper").toggleClass("open");

    headerSearchButton.classList.toggle("open");
    searchForm.classList.add("open-search");
  };

  const searchCloseHandler = () => {
    $(
      ".site-header-naviation, .phone-content, .search-icon, .search-open-icon, .site-header-search"
    ).toggle();

    $(".search-wrapper").toggleClass("open");
    headerSearchButton.classList.toggle("open");
    searchForm.classList.remove("open-search");
  };

  // Toggle the .toggled class and the aria-expanded value each time the button is clicked.
  headerSearchButton.addEventListener("click", function (e) {
    e.preventDefault();
    $(".search-field").focus();
    searchOpenHandler();
  });

  headerSearchButton.addEventListener("focus", (event) => {
    searchOpenHandler();
  });

  closeBtn.addEventListener("click", function (e) {
    searchCloseHandler();
  });

  submitIcon.addEventListener("click", function (e) {
    $(".search-submit").trigger("click");
  });
})();
